import React, { useEffect, useState } from "react";
import { Package, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

const fmtDate = (iso) => { try { return new Date(iso).toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric" }); } catch { return "—"; } };

export default function MemberPackages() {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/members/me").then((r) => setM(r.data)); }, []);

  if (!m) return <Skeleton className="h-48 rounded-2xl bg-[#13131C]" />;
  const pct = m.total_lessons ? Math.round((m.remaining_lessons / m.total_lessons) * 100) : 0;

  return (
    <div data-testid="member-packages-page">
      <h1 className="font-display font-extrabold text-2xl text-white mb-1">Paketlerim</h1>
      <p className="text-sm text-[#68687B] mb-5">Aktif paketin ve kalan ders hakların</p>

      {m.package_name ? (
        <div className="rounded-3xl bg-gradient-to-br from-[#181824] to-[#13131C] border border-[#FF5500]/30 p-6">
          <div className="flex items-center justify-between">
            <div className="w-12 h-12 rounded-2xl bg-[#FF5500]/15 flex items-center justify-center"><Package size={24} className="text-[#FF5500]" /></div>
            <span className="text-[11px] font-bold uppercase px-2.5 py-1 rounded-full bg-[#10B981]/15 text-[#10B981] border border-[#10B981]/30">Aktif</span>
          </div>
          <h2 className="font-display font-bold text-xl text-white mt-4">{m.package_name}</h2>
          <div className="flex items-baseline gap-2 mt-4">
            <span className="font-mono font-black text-5xl text-[#FF5500]">{m.remaining_lessons}</span>
            <span className="text-[#68687B]">/ {m.total_lessons} ders kaldı</span>
          </div>
          <div className="h-2.5 rounded-full bg-[#1B1B27] mt-3 overflow-hidden"><div className="h-full bg-gradient-to-r from-[#FF5500] to-[#FF7733] rounded-full" style={{ width: `${pct}%` }} /></div>
          <div className="flex items-center gap-2 mt-4 text-sm text-[#A0A0B2]"><CheckCircle2 size={16} className="text-[#10B981]" /> Son kullanma: {fmtDate(m.package_expiry)}</div>
        </div>
      ) : (
        <div className="text-center py-20 text-[#68687B]">Aktif paketin bulunmuyor.</div>
      )}
    </div>
  );
}
